import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEdit, FaSearch, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const RoboticsKitList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [levelFilter, setLevelFilter] = useState("");
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();

  useEffect(() => {
    callAPI("get", "admin/robotic-kits", "");
  }, []);

  const deleteRecord = (id) => {
    callAPI("delete", `admin/robotic-kits/${id}`, "");
  };

  useEffect(() => {
    if (statusCode === 204 && !isDelete) {
      toast.success("Robotics Kit deleted successfully!");
      callAPI("get", "admin/robotic-kits", "");
      setIsDelete(true);
    }
  }, [statusCode, isDelete]);

  useEffect(() => {
    if (response?.data && statusCode === 200) {
      setList(response.data);
      setIsDelete(false);
    }
  }, [response, statusCode]);

  const filteredKits = list.filter(
    (kit) =>
      kit.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (levelFilter ? kit.level === levelFilter : true)
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Robotics Kit List"
                subTitle="Manage all Robotics Kits"
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.roboticskit.add}>
                <button className="btn btn-primary">Add Kit</button>
              </Link>
            </div>
          </div>

          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by kit name"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={levelFilter}
                    onChange={(e) => setLevelFilter(e.target.value)}
                  >
                    <option value="">Filter by level</option>
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Advance">Advance</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Image</th>
                    <th className="px-4 py-2">Name</th>
                    <th className="px-4 py-2">Grades</th>
                    <th className="px-4 py-2">Age</th>
                    <th className="px-4 py-2">Level</th>
                    <th className="px-4 py-2">Price (₹)</th>
                    <th className="px-4 py-2">Projects</th>
                    <th className="px-4 py-2">Learning Points</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredKits.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center py-4">
                        No robotics kits found.
                      </td>
                    </tr>
                  ) : (
                    filteredKits.map((kit, index) => (
                      <tr key={kit.id} className="sys-list-table__row border-bottom">
                        <td className="px-4 py-2">{index + 1}</td>
                        <td className="px-4 py-2">
                          <img
                            src={kit.image || "https://via.placeholder.com/40"}
                            alt={kit.name}
                            className="rounded"
                            style={{ width: "40px", height: "40px", objectFit: "cover" }}
                          />
                        </td>
                        <td className="px-4 py-2">{kit.name}</td>
                        <td className="px-4 py-2">{kit.grades}</td>
                        <td className="px-4 py-2">{kit.age}</td>
                        <td className="px-4 py-2">{kit.level}</td>
                        <td className="px-4 py-2">{kit.price}</td>
                        <td className="px-4 py-2">
                          {kit.projects.map((proj, i) => (
                            <div key={i} className="mb-1">
                              <strong>{proj.name}</strong>
                              {proj.file && proj.file.length > 0 && (
                                <ul className="mb-0 ps-3">
                                  {proj.file.map((f, idx) => (
                                    <li key={idx}>
                                      <a href={f} target="_blank" rel="noopener noreferrer">
                                        File {idx + 1}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                        </td>
                        <td className="px-4 py-2">
                          <ul className="mb-0 ps-3">
                            {kit.what_you_learn.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </td>
                        <td className="px-4 py-2 text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <Link to={uiRoutes.admin.roboticskit.edit.replace(":id", kit.id)}>
                              <button
                                className="sys-list-table__action edit"
                                title="Edit Robotics Kit"
                              >
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete Robotics Kit"
                              onClick={() => deleteRecord(kit.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default RoboticsKitList;
